import { httpClient } from "../http/httpClient";

export async function ApproveWithdraw(id: string) {
  const { data } = await httpClient.patch(`/withdraw/${id}/approve`);

  return data;
}
